import { ifStatement } from 'babel-types'
import { getGeoLocation } from '~/plugins/util/deviceUtils'

export const state = () => ({
  current: null,
  general: {
    score: { grade: 0 },
  },
})

export const getters = {
  currentQuestions: state => {
    const quiz = state.current
    if (!quiz) return { count: 0, answered: 0, list: [] }
    const { questions } = quiz.video
    return {
      count: questions.length,
      answered: questions.filter(({ answer }) => answer).length,
      list: questions,
    }
  },
}

export const mutations = {
  UPDATE_ROOT: (state, payload) => Object.assign(state, payload),
}

export const actions = {
  async fetchState({ commit }) {
    const { data } = await this.$axios.get('/v2/app/quiz/currentState')
    commit('UPDATE_ROOT', data)
  },
  async start({ commit }, id) {
    this.$axios.put('/v3/app/training-content-log/tv-sales', {
      contentId: id,
      status: 'start_quiz',
    })
    const { data } = await this.$axios.post(
      `/v2/app/quiz/video/${id}/startQuiz`
    )
    return data
  },
  async finish({ commit, state }, coacheeCode) {
    const { data } = await this.$axios.post('/v2/app/quiz/finishQuiz', {})
    this.$axios.put('/v3/app/training-content-log/tv-sales', {
      contentId: state.current.video._id,
      status: 'end_quiz',
    })
    commit('UPDATE_ROOT', data)
  },
  async answerQuestion({ commit }, { questionIndex, answer }) {
    const { data } = await this.$axios.post(
      `/v2/app/quiz/question/answer/${questionIndex}`,
      answer
    )
    commit('UPDATE_ROOT', data)
  },
}
